import axios from 'axios';
const RESOURCE_NAME = '/contacts';

export default {

    GetContact(local) {
        return axios.get(`${RESOURCE_NAME}/${local}`)
    },
}